/* eslint-disable @typescript-eslint/no-shadow */
import type { ui } from 'angular';
import ngAnnotate from '../ngAnnotate.macro';
import modalTemplate from '../directive/cancelRemainingAppointmentsModal.html';

class NoMoreShowingsService {
  constructor(
    readonly $resource: ng.resource.IResourceService,
    readonly $uibModal: ui.bootstrap.IModalService,
  ) {}

  showNoMoreShowingsWarning = (
    noMoreShowings: boolean,
    listingId: string,
    cb?: (noMoreShowingsSet: boolean) => void,
  ) => {
    const SetNoMoreShowings = this.$resource(
      '/listing/:listingId/appointments/config/noMoreShowings/:noMoreShowings',
      {
        listingId: '@listingId',
        noMoreShowings: '@noMoreShowings',
      },
    );
    const CancelRemainingAppointments = this.$resource(
      '/listing/:listingId/appointments/config/cancelRemaining',
      {
        listingId: '@listingId',
      },
    );

    const cancelRemainingAppointments = (
      appointmentsToCancel: todo,
      callback: () => void,
    ) => {
      const cancelRemainingAppointmentsInstance =
        new CancelRemainingAppointments({
          listingId,
          appointmentsToCancel,
        });
      cancelRemainingAppointmentsInstance.$save(() => {
        swal({
          title: 'Showings Have Been Cancelled',
          type: 'success',
          confirmButtonColor: '#62cb31',
          confirmButtonText: 'Done',
        });
        return callback();
      });
    };

    const setNoMoreShowings = (noMoreShowings: boolean, cb: () => void) => {
      const setNoMoreShowingsInstance = new SetNoMoreShowings({
        listingId,
        noMoreShowings,
      });
      setNoMoreShowingsInstance.$save((appointmentMeta: todo) => {
        if (noMoreShowings && appointmentMeta.pendingAppointments.length > 0) {
          return showCancelRemainingAppointmentsWarning(appointmentMeta, cb);
        }

        return cb();
      });
    };

    const showCancelRemainingAppointmentsWarning = (
      appointmentMeta: todo,
      cb: () => void,
    ) => {
      const modalInstance = this.$uibModal.open({
        template: modalTemplate,
        controller: 'CancelRemainingAppointmentsController',
        windowClass: 'cancel-remaining-modal',
        resolve: {
          pendingAppointments: () => appointmentMeta.pendingAppointments,
          listingId: () => listingId,
        },
      });

      modalInstance.result.then(
        appointmentsToCancel =>
          cancelRemainingAppointments(appointmentsToCancel, cb),
        () => cb(),
      );
    };

    const invokeCb = (noMoreShowingsSet: boolean) => {
      if (cb) return cb(noMoreShowingsSet);
    };

    if (noMoreShowings) {
      swal(
        {
          title: 'NO MORE SHOWINGS',
          text: "Are you sure you'd like to stop further showings on this property?",
          html: true,
          type: 'warning' as any,
          confirmButtonColor: '#cb4800',
          confirmButtonText: 'Yes',
          showCancelButton: true,
          closeButtonText: 'Cancel',
          closeOnConfirm: true,
        } as SweetAlert.Settings & SweetAlert.PromtModalSettings,
        (noMoreShowings) => {
          setNoMoreShowings(noMoreShowings as todo, () =>
            invokeCb(noMoreShowings as todo),
          );
        },
      );
    } else {
      return setNoMoreShowings(noMoreShowings, () => invokeCb(false));
    }
  };
}

ngAnnotate(NoMoreShowingsService);

export default NoMoreShowingsService;
